import { differentVatFormat } from '@helpers/countrySpecificRules';
import { MakeTroubleshootRoute } from '@models/Filing/aggregatesSummary/helpers/makeTroubleshootRoute/types';
import { vfileRoutes } from '@routes';

/**
 * Makes the troubleshooting route
 */
export const makeTroubleshootRoute: MakeTroubleshootRoute =
  (countryIso, filingPeriodId, disableOnlineTroubleshoot = false) =>
  (useMassTroubleshoot = false) =>
    differentVatFormat(countryIso || '') || disableOnlineTroubleshoot || useMassTroubleshoot
      ? () => vfileRoutes.FILING_MASS_TROUBLESHOOT.make(filingPeriodId ?? '')
      : rowId => vfileRoutes.FILING_TROUBLESHOOT.make(filingPeriodId ?? '', rowId ?? '');
